import React, { useEffect, useState } from "react";
import "../styles/Lightbox.css";

const Lightbox = ({ images = [], initialIndex = 0, onClose }) => {
  const [index, setIndex] = useState(initialIndex || 0);

  useEffect(() => {
    setIndex(initialIndex || 0);
  }, [initialIndex]);

  //   useEffect(() => {
  //     const handleKey = (e) => {
  //       if (e.key === "Escape") onClose();
  //       if (e.key === "ArrowRight") next();
  //       if (e.key === "ArrowLeft") prev();
  //     };
  //     //document.addEventListener("keydown", handleKey);
  //     // const prevOverflow = document.body.style.overflow;
  //     // document.body.style.overflow = "hidden";
  //     // add body class to hide header navigation while lightbox is open
  //     //document.body.classList.add("lightbox-open");
  //     return () => {
  //       //document.removeEventListener("keydown", handleKey);
  //       //document.body.style.overflow = prevOverflow;
  //       //document.body.classList.remove("lightbox-open");
  //     };
  //   }, [index, onClose]);

  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
  const next = () => setIndex((i) => (i + 1) % images.length);

  if (!images || images.length === 0) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <button className="lightbox-prev" onClick={prev} aria-label="Previous">
          ‹
        </button>
        <img
          src={images[index]}
          alt={`Slide ${index + 1}`}
          className="lightbox-image"
        />
        <button className="lightbox-next" onClick={next} aria-label="Next">
          ›
        </button>
        <div className="lightbox-footer">
          <div className="lightbox-counter">
            {index + 1} / {images.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lightbox;
